import React from "react";
import FloatingLabelInput from "./floating-label-input";
import DateOfBirthSelect from "./date-of-birth-select";
import AddressInput from "./address-input";
import UkAddressInput from "./uk-address-input";
import DeAddressInput from "./de-address-input";
import {
  getAddressRegion,
  isDayFirstRegion,
  ADDRESS_REGION_UK,
  ADDRESS_REGION_DE,
} from "../utils/addressRegion";

const FormField = ({
  field,
  form,
  settings,
  componentKey,
  showMoreFields,
  onDobChange,
  onAddressChange,
  isSinglePageForm = false,
  disabled = false,
}) => {
  const shouldSkipValidation =
    componentKey === "idmatch/coppa" &&
    !showMoreFields &&
    (field.name === "dob" || field.name === "ssn");

  const inputProps = shouldSkipValidation
    ? {
        value: form.values[field.name] || "",
        onChange: (event) =>
          form.setFieldValue(field.name, event.target.value),
      }
    : form.getInputProps(field.name);

  // UK and DE routes collect a regional address and write dates day-first.
  const addressRegion = getAddressRegion(settings, componentKey);

  if (field.type === "date") {
    return (
      <DateOfBirthSelect
        key={field.name}
        onDobChange={onDobChange}
        isSinglePageForm={isSinglePageForm}
        dayFirst={field.dayFirst ?? isDayFirstRegion(addressRegion)}
        placeholder={field.placeholder}
        {...inputProps}
        disabled={disabled}
      />
    );
  }

  if (field.type === "address") {
    if (componentKey === "agematch/process") {
      console.log("🏠 AgeMatch address region:", {
        addressRegion,
        componentKey,
        settings: settings?.journey?.settings,
        matchedRoute: settings?.journey?.route?.find((r) => r.path === componentKey),
      });
    }

    const AddressComponent =
      addressRegion === ADDRESS_REGION_DE
        ? DeAddressInput
        : addressRegion === ADDRESS_REGION_UK
          ? UkAddressInput
          : AddressInput;

    return (
      <AddressComponent
        key={field.name}
        onAddressChange={onAddressChange}
        showCityState={field.showCityState !== false}
        stacked={field.stacked === true}
        enterKeyHint={field.enterKeyHint}
        streetLabel={field.streetLabel}
        cityLabel={field.cityLabel}
        stateLabel={field.stateLabel}
        zipLabel={field.zipLabel}
        zipCodeLabel={field.zipCodeLabel}
        errorMessage={field.errorMessage}
        {...inputProps}
        value={{
          addr: form.values.addr,
          city: form.values.city,
          state: form.values.state,
          zip: form.values.zip,
        }}
        disabled={disabled}
      />
    );
  }

  // Special handling for phone field
  if (field.name === "phone") {
    return (
      <FloatingLabelInput
        key={field.name}
        size="xl"
        label={field.label}
        inputMode="tel"
        autoComplete="tel"
        placeholder={field.placeholder}
        {...inputProps}
        disabled={disabled}
        customOnChange={(event) => {
          let value = event.target.value || "";
          value = value.replace(/\D/g, "").substring(0, 10);
          value = value.replace(
            /(\d{3})(\d{3})(\d{4})/,
            "$1-$2-$3"
          );
          inputProps.onChange(value);
          form.setFieldValue("phone", value);
        }}
      />
    );
  }

  return (
    <FloatingLabelInput
      key={field.name}
      size="xl"
      label={field.label}
      isPassword={field.isPassword}
      isMaskedInput={field.isMaskedInput}
      maxLength={field.maxLength}
      autoComplete={field.autoComplete}
      enterKeyHint={field.enterKeyHint}
      {...inputProps}
      disabled={disabled}
    />
  );
};

export default FormField;

